import { defaultTheme } from '@/theme';

const blue = defaultTheme.mantineColors.blue;
const red = defaultTheme.mantineColors.red;
export const gray = defaultTheme.mantineColors.gray;

export type Variant =
  | 'blue-filled'
  | 'red-filled'
  | 'blue-outlined'
  | 'gray-outlined'
  | 'red-outlined'
  | 'blue-transparent'
  | 'gray-transparent'
  | 'red-transparent';

export type ColorScheme = {
  backgroundColor: {
    default: string;
    hover: string;
    pressed: string;
    disabled: string;
  };
  text: {
    default: string;
    disabled: string;
  };
  border: {
    default: string;
    disabled: string;
  };
};

const BLUE_FILLED: ColorScheme = {
  backgroundColor: {
    default: blue[6],
    hover: blue[7],
    pressed: blue[8],
    disabled: gray[4],
  },
  text: {
    default: gray[1],
    disabled: gray[6],
  },
  border: {
    default: 'transparent',
    disabled: 'transparent',
  },
};

const RED_FILLED: ColorScheme = {
  backgroundColor: {
    default: red[6],
    hover: red[7],
    pressed: red[8],
    disabled: gray[4],
  },
  text: {
    default: gray[1],
    disabled: gray[6],
  },
  border: {
    default: 'transparent',
    disabled: 'transparent',
  },
};

const BLUE_OUTLINED: ColorScheme = {
  backgroundColor: {
    default: gray[1],
    hover: blue[1],
    pressed: blue[2],
    disabled: gray[1],
  },
  text: {
    default: blue[6],
    disabled: gray[5],
  },
  border: {
    default: blue[6],
    disabled: gray[3],
  },
};

const GERY_OUTLINED: ColorScheme = {
  backgroundColor: {
    default: gray[1],
    hover: gray[2],
    pressed: gray[3],
    disabled: gray[1],
  },
  text: {
    default: gray[7],
    disabled: gray[5],
  },
  border: {
    default: gray[4],
    disabled: gray[3],
  },
};

const RED_OUTLINED: ColorScheme = {
  backgroundColor: {
    default: gray[1],
    hover: red[1],
    pressed: red[2],
    disabled: gray[1],
  },
  text: {
    default: red[6],
    disabled: gray[5],
  },
  border: {
    default: red[6],
    disabled: gray[3],
  },
};

const BLUE_TRANSPARENT: ColorScheme = {
  backgroundColor: {
    default: gray[1],
    hover: defaultTheme.createRGBAWithHex(blue[6], 0.05),
    pressed: defaultTheme.createRGBAWithHex(blue[6], 0.1),
    disabled: gray[1],
  },
  text: {
    default: blue[6],
    disabled: gray[5],
  },
  border: {
    default: 'transparent',
    disabled: 'transparent',
  },
};

const GRAY_TRANSPARENT: ColorScheme = {
  backgroundColor: {
    default: 'transparent',
    hover: defaultTheme.createRGBAWithHex(gray[8], 0.05),
    pressed: defaultTheme.createRGBAWithHex(gray[8], 0.1),
    disabled: gray[1],
  },
  text: {
    default: gray[7],
    disabled: gray[5],
  },
  border: {
    default: 'transparent',
    disabled: 'transparent',
  },
};

const RED_TRANSPARENT: ColorScheme = {
  backgroundColor: {
    default: gray[1],
    hover: defaultTheme.createRGBAWithHex(red[6], 0.05),
    pressed: defaultTheme.createRGBAWithHex(red[6], 0.1),
    disabled: gray[1],
  },
  text: {
    default: red[6],
    disabled: gray[5],
  },
  border: {
    default: 'transparent',
    disabled: 'transparent',
  },
};

export const VARIANT_MAP: { [key in Variant]: ColorScheme } = {
  'blue-filled': BLUE_FILLED,
  'red-filled': RED_FILLED,
  'blue-outlined': BLUE_OUTLINED,
  'gray-outlined': GERY_OUTLINED,
  'red-outlined': RED_OUTLINED,
  'blue-transparent': BLUE_TRANSPARENT,
  'gray-transparent': GRAY_TRANSPARENT,
  'red-transparent': RED_TRANSPARENT,
} as const;
